<div [class]="classes()" [attr.aria-label]="label()">
  <svg class="alert__icon" [ftrIcon]="actualIcon()" [iconSize]="24"></svg>
  @if (renderAsMarkdown()) {
    <span markdown class="alert__message" [renderAllBreaks]="true">
      <ng-container *ngTemplateOutlet="content" />
    </span>
  } @else {
    <span class="alert__message">
      <ng-container *ngTemplateOutlet="content" />
    </span>
  }
</div>

<ng-template #content>
  <ng-content />
</ng-template>
